import { Trans, t } from '@lingui/macro';
import { BadgeIcon, Icon, Tooltip } from '@economic/taco';

export default function SubscriptionBasisDialog() {
    return (
        <div>
            <div className="items-center mt-4">
                <h2>
                    <Trans>Standard package</Trans>
                </h2>
            </div>
            <div className="pb-5">
                <Trans>
                    In the Basic package, you'll find our core features for digital warehouse management. The package is suitable
                    for both small businesses and larger businesses with a simpler workflow for their inventory.
                </Trans>
            </div>
            <div className="flex flex-row items-start">
                <div className="flex flex-col ">
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Full product overview</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Order management</Trans>
                        <Tooltip
                            title={t`Choose between webshop order management (automatic inventory update) and B2B order management (manual order creation).`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Procurement management</Trans>
                        <Tooltip
                            title={t`Purchase management allows you to order and register items, keeping inventory and accounting up to date.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Discount management</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Reporting</Trans>
                        <Tooltip
                            title={t`Get a detailed overview of your inventory with reports that include order counts, sales, and purchases.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Re-order recommendations</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Location management</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Import and export CSV files</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Efficient picking and packing</Trans>
                    </span>
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Dropshipping</Trans>
                        <Tooltip
                            title={t`With dropshipping, you can store items with an external supplier created in Rackbeat. When a customer orders, the item is shipped directly from the supplier to the customer, while the invoice is issued in your company's name and address.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className=" flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Quality assurance of products upon receipt</Trans>
                    </span>
                </div>
                <div className="flex flex-col ml-8">
                    <span className="flex items-center">
                        <Icon name="tick" className="text-blue-700" />
                        <Trans>Sublocations</Trans>
                        <Tooltip
                            title={t`With the Premium package, you can divide your warehouse into sublocations, such as aisles, shelves, and slots, and generate reports for each sublocation.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Option for FIFO inventory</Trans>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Parts lists</Trans>
                        <Tooltip
                            title={t`Parts lists are essential for manufacturing companies. Assemble your finished goods or final product from the component parts, also known as item collections.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Production overview</Trans>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Access to the mobile app</Trans>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Custom fields</Trans>
                        <Tooltip
                            title={t`Use custom fields to customize and display necessary information in PDFs for customers, suppliers, as well as product, order, and inventory overviews.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="opacity-50 flex items-center">
                        <Icon name="close" className="text-blue-700" />
                        <Trans>Unit converter</Trans>
                        <Tooltip
                            title={t`Manage and sell your items in various units, such as pieces, pallets, boxes, and gift boxes.`}>
                            <BadgeIcon icon="info" color="blue" className="ml-1" small subtle />
                        </Tooltip>
                    </span>
                    <span className="opacity-50 flex items-start">
                        <div className="flex flex-col items-start">
                            <Icon name="close" className="text-blue-700" />
                        </div>
                        <div className="flex flex-col items-start">
                            <Trans>Unlimited no. of Rackbeat integrations</Trans>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    );
}
